import moment from 'moment';
import {
  FIRST,
  SECOND,
  THIRD,
  FOURTH,
  LAST,
  MON,
  TUE,
  WED,
  THU,
  FRI,
  SAT,
  SUN,
  DAY
} from '../utils/recurrence';

export const getOrdinalOptions = (locale, hideLastDayInDays) => (
  Array(hideLastDayInDays ? 31 : 32).fill().map((_, index) => {
    const idx = hideLastDayInDays ? index + 1 : index;

    return {
      label: idx === 0 ? locale.get('schedulerReact.last') : moment(`2019-10-${idx >= 10 ? idx : `0${idx}`}`).format('Do'),
      value: idx.toString()
    };
  })
);

export const getOrdinalDayOptions = (locale) => [
  {
    label: locale.get('schedulerReact.last'),
    value: LAST
  },
  {
    label: locale.get('schedulerReact.first'),
    value: FIRST
  },
  {
    label: locale.get('schedulerReact.second'),
    value: SECOND
  },
  {
    label: locale.get('schedulerReact.third'),
    value: THIRD
  },
  {
    label: locale.get('schedulerReact.fourth'),
    value: FOURTH
  }
];

export const getDayOptions = (locale, allowWeekend) => {
  const dayOptions = [
    {
      label: locale.get('schedulerReact.day'),
      value: DAY
    },
    {
      label: locale.get('schedulerReact.monday'),
      value: MON
    },
    {
      label: locale.get('schedulerReact.tuesday'),
      value: TUE
    },
    {
      label: locale.get('schedulerReact.wednesday'),
      value: WED
    },
    {
      label: locale.get('schedulerReact.thursday'),
      value: THU
    },
    {
      label: locale.get('schedulerReact.friday'),
      value: FRI
    }
  ];

  if (allowWeekend) {
    dayOptions.push(
      {
        label: locale.get('schedulerReact.saturday'),
        value: SAT
      },
      {
        label: locale.get('schedulerReact.sunday'),
        value: SUN
      }
    );
  }
  return dayOptions;
};
